import { Component, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { TextareaQuestion } from 'core/components/forms/question-textarea';
import { ListComponent } from 'core/components/list/list.component';
import { StoreService } from 'core/services/store.service';
import { ToastService } from 'core/services/toast.service';

import { Message } from './message';
import { MessagesService } from './messages.service';

@Component({
  selector: 'lms-mars1-messages',
  templateUrl: './mars1-messages.component.html',
  styleUrls: ['./mars1-messages.component.scss'],
  providers: [MessagesService]
})
export class Mars1MessagesComponent implements OnChanges {
  @Input() listId: string;
  @Input() options: any;
  @Input() group: any;
  public groupMessagesListId = 'MARS_GROUP_MESSAGES_LIST';
  @Output() listUpdated: EventEmitter<any> = new EventEmitter<any>();
  public defaultOptions: any = { sort: '-created_at', elementsName: 'groupMessages.label' };
  public listOptions: any;
  @ViewChild(ListComponent, { static: false }) public listComponent: ListComponent;

  public message: any;
  public textarea: TextareaQuestion;

  messages: Message[];

  constructor(public messagesService: MessagesService, public toastService: ToastService) {}

  ngOnChanges() {
    this.listOptions = Object.assign({}, this.defaultOptions, this.options);
    this.listOptions.filters = new Map<string, string>(this.listOptions.filters);
    this.listOptions.filters.set('type', 'RRHH_MESSAGE');
  }

  sendMessage() {
    const payload = {
      groupId: this.group.id,
      message: this.message
    };
    this.message = null;
    this.messagesService
      .create(payload)
      .then(() => {
        StoreService.merge(this.listId, { active: true });
        this.toastService.showOk('', 3000, false);
      })
      .catch((error) => {
        this.toastService.showError(error, '', true);
        this.message = payload.message;
      });
  }

  setCollection(collection) {
    this.messages = collection;
    this.listUpdated.emit(collection);
  }
}
